
import { Component, OnDestroy, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { UserService } from '../../../auth/services/user.service';
import { concat, Subscription } from 'rxjs';
import { User } from '../../../auth/models/user.model';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { CommunService } from '../../../../shared/services/commun';
import Swal from 'sweetalert2';
import { TokenStorageService } from '../../../auth/services/token-storage.service';
import { read, utils } from 'xlsx';
import { dataService } from '../../../../shared/services/data.service';
import { datacommService } from '../../../../shared/services/datacomm.service';
@Component({
  selector: 'app-admin-board',
  templateUrl: './admin-board.component.html',
  styleUrls: ['./admin-board.component.scss']
})
export class AdminBoardComponent implements OnInit {
  public searchForm: FormGroup;
  public loading: boolean;
  public users: User[] = [];
  public users2: User[]= [];

  public filtredusers: User[] = [];
  private condidatesSub: Subscription;
  private contactsSub: Subscription;
  private usersSub: Subscription;
  private usersdeletedSub: Subscription;
  private decfiscmenssSub: Subscription;
  private deccomptabilitesSub: Subscription;
  prenom:string;
  nom:string
  errormsg:string;
  firstname:string;
  lastname:string;
  statut:string;
  email:string;
  date:Date;
  firstnamedecomptabilite:string
  lastnamedeccomptabilite:string
  filtredusers2: User[] = [];
  prenomfisc: string
  nomfisc: string
  clientactif=false
  clientbloque=false
  clientsupptemporairement=false
  collaborateurs=false
  consultants=false
  candidat=false
  decfiscmensvalide=false
  decfiscmensnonvalide=false
  deccomptabilitevalide=false
  deccomptabilitenonvalide=false
  candidaturevalide=false
  candidaturenonvalide=false
  reclamationtraite=false
  reclamationnontraite=false
  clienttotal=0;
  utilconnecte=0;
  ca=0;
  cb=0;
  coll=0;
  cons=0;
  decfiscvali=0;
  decfiscnonvali=0;
  deccomptvalid=0;
  deccompnonval=0;
  del=0;
  condval=0;
  condnonal=0;
  contval=0;
  contnonval=0;
  condida=0;
  dossdecfiscencours=0;
  dossdeccompencours=0;
  dosscandencours=0;
  dosscontactencours=0;
  dossencours: any[]=[];
  showdossencours: boolean;

  showdosspasencoreaffecte: boolean;
  dossdecfiscnonaffecte=0;
  dossdeccompnonaffecte=0;
  dosscandnonaffecte=0;
  dosscontactnonaffecte=0;

  dossnonaffecte: any[]=[];
  prenomaffecte: string;
  nomaffecte: string;
  sorteddossencours: any[]=[];
  sorteddossnonaffecte: any[]=[];

  dossencoursvalide: any[]=[];
  dossencoursnonvalide: any[]=[];
  showdallusers: boolean;
  showconnected: boolean;
  checkedusers: any[]=[];
  showcartewindow: boolean;
  showcommwindow: boolean;
  file: any;
  uploadEvent: any;
  arrayBuffer: string | ArrayBuffer;
  exceljsondata6: unknown[]=[];
  exceljsondata7: unknown[]=[];
  currentuser: User;
  exceljsondata2: User[]=[];
  showmultipleusersindow: boolean;
  adminboard: boolean =false;
  role: string;
  usertype: string;
  constructor(private formBuilder: FormBuilder,
              private UserService: UserService,
            private commun: CommunService,
              private router: Router,private Auth: TokenStorageService,private data: dataService,private datacomm: datacommService,private route: ActivatedRoute
            ) { }
  // Object to keep track of open/close state of accordions
  accordionState: { [key: string]: boolean } = {
    users: false,
    stats: false,
    fichiers: false

  };

  // Toggles the accordion state
  toggleAccordion(sectionId: string) {
    this.accordionState[sectionId] = !this.accordionState[sectionId];
  }

  // Checks if a specific accordion is open
  isAccordionOpen(sectionId: string): boolean {
    return this.accordionState[sectionId];
  }
  onFileChange6(event) {
    if (event.target.files.length > 0) {
      this.file = event.target.files[0];
      this.uploadEvent = event;
    }
    let fileReader = new FileReader();
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      //@ts-ignore
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i)
        arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = read(bstr, {
        type: "binary"
      });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];
      this.exceljsondata6 = utils.sheet_to_json(worksheet, {
        raw: true,
        defval: "",
      });
    };
    fileReader.readAsArrayBuffer(this.file);
  }
  onFileChange7(event) {
    if (event.target.files.length > 0) {
      this.file = event.target.files[0];
      this.uploadEvent = event;
    }
    let fileReader = new FileReader();
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      //@ts-ignore
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i)
        arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = read(bstr, {
        type: "binary"
      });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];
      this.exceljsondata7 = utils.sheet_to_json(worksheet, {
        raw: true,
        defval: "",
      });
    };
    fileReader.readAsArrayBuffer(this.file);
  }    
  savedata()
  {
    this.loading = true;
    this.data.createdata(this.exceljsondata6).then(
      (data:any) => {
        this.loading = false;
  Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'relations ajoutées avec succès!',
          showConfirmButton: false,
          timer: 6000 
        });
            this.reloadPage();
      },
      (error) => {
        this.loading = false;
        
      }
    );
  }
  savedatacomm()
  {
    this.loading = true;
    this.datacomm.createdata(this.exceljsondata7).then(
      (data:any) => {
        this.loading = false;
  Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'relations ajoutées avec succès!',
          showConfirmButton: false,
          timer: 6000 
        });
            this.reloadPage();
      },
      (error) => {
        this.loading = false;
        
      }
    );
  }       
              ngOnInit() {
                const currentuser = this.Auth.getUser();
                this.UserService.getUserById(currentuser.userId).then(
                  (user:User)=>{
                    this.role = user.role;
                    this.usertype=user.usertype
                  }
                )
                this.usersSub = this.UserService.users$.subscribe(
                  (users) => {
                    this.users = users;
                    this.users2= users
                    this.loading = false;
                  },
                  (error) => {
                    this.loading = false;
                    this.errormsg=error.message;
                  }
                );
               
                this.usersdeletedSub = this.UserService.usersdeleted$.subscribe(
                  (usersdeleted) => {
                    this.loading = false;
                  },
                  (error) => {
                    this.loading = false;
                    this.errormsg=error.message;
                  }
                );
                this.UserService.getUserById(currentuser.userId).then(
                  (user:User)=>{
                    this.currentuser=user
                    if (user.role=='superadmin')
                    {
                      this.UserService.getAll();
                    }
                    else     if (user.role=='adminbanque')
                    {
                      this.UserService.getadminbanqueAll(user.banque);
                    }
                    else     if (user.role=='userbanque')
                    {
                      this.UserService.getuserbanqueAll(user.banque);
                    }
                  }
                )
                this.route.params.subscribe(
                  params => {
                      switch(params['type'])
                      {
                        case 'consultusers':
                          this.showdallusers=true
                          this.showcartewindow=false            
                          this.showcommwindow=false            
                          this.showmultipleusersindow=false            
                          break;
                          case 'multiporteurs':
                            this.showcartewindow=true    
                            this.showdallusers=false            
                            this.showcommwindow=false            
                            this.showmultipleusersindow=false  
                          break;
                          case 'multimerchants':
                            this.showcommwindow=true    
                            this.showdallusers=false            
                            this.showcartewindow=false     
                            this.showmultipleusersindow=false            
   
                          break;
                          case 'multiusers':
                            this.showmultipleusersindow=true     
                            this.showdallusers=false            
                            this.showcartewindow=false            
                            this.showcommwindow=false        
                          break;
                          default:
                            this.showdallusers=true            
                            this.showcartewindow=true            
                            this.showcommwindow=true            
                            this.showmultipleusersindow=true            
                      }
                    
          
                  }
                )
                }
                returnprofil()
                {
                  let profil=''
                  if (this.role=='userbanque'&&this.usertype=='Metier')
                  {
              profil= 'metierbanque'
                  }
                  else if (this.role=='userbanque'&&this.usertype=='Clientpor'||this.role=='basic'&&this.usertype=='Clientpor')
                  {
              profil= 'porteur'
                  }
                  else if (this.role=='userbanque'&&this.usertype=='Clientcomm'||this.role=='basic'&&this.usertype=='Clientcomm')
                  {
              profil= 'commercant'
                  }
                  else if (this.role=='userbanque'&&this.usertype=='Agence')
                  {
              profil= 'agence'
                  }
                  else if (this.role=='adminbanque')
                  {
              profil= 'adminbanque'
                  }
                  else if (this.role=='superadmin')
                  {
              profil= 'superadmin'
                  }
                  else if (this.usertype=='comite arbitrage')
                  {
              profil= 'comite'
                  }
                  return profil
                }
              getNavigationusers(link, id){
      
                this.UserService.getUserById(id);
                this.router.navigate([link + '/' + id]); 
              }
           
              getallusers() {
                
                this.clienttotal=this.users.length
                return this.users; 
              }                   
       selectallusers()
       {
        this.checkedusers=[]
        for (let i = 0; i < this.users.length ; i++) 
        {
         var checkbox:any = document.getElementById('user'+`${i}`);  
         checkbox.checked=true
         this.checkedusers.push(this.users[i]._id)
         console.log(checkbox.checked)
       }
       console.log(this.checkedusers.length)
      }
      async deletemultiusers()
      {
        Swal.fire({
          title: 'Suppression utilisateurs',
          showCancelButton: true,
          confirmButtonText: 'Supprimer',
          cancelButtonText: 'Annuler',
        }).then(async (result) => {
          if (result.isConfirmed) {
            for  (let i = 0; i < this.users.length ; i++) 
            {
              var checkbox:any = document.getElementById('user'+`${i}`);  
              if(checkbox.checked==true)
              {
              await this.UserService.deleteUserById(this.users[i]._id)
              }
           }
           this.reloadPage()
            Swal.fire('Succès', 'Tous les utilisateurs sont supprimés avec succès', 'success');
          }
        });
      }
          exportusersAsXLSX(source:any[],name:string):void {
          }
          onTabClick(event) {
   
          }
          click1()
          {
            this.showdallusers=true
          }
          click2()
          {
            this.showdallusers=false
          }
          showstats()
          {}
          showlog()
          {

          }
          showcarte()
          {
this.showcartewindow=true
          }
          hidecarte()
          {
            this.showcartewindow=false

          }
          showcomm()
          {
            this.showcommwindow=true

          }
          hidecomm()
          {
            this.showcommwindow=false

          }
          showmultipleusers()
          {
            this.showmultipleusersindow=true

          }
          hidemultipleusers()
          {
            this.showmultipleusersindow=false

          }
          onDelete(id:any) {
            this.UserService.deleteUserById(id);
          }
          reloadPage(): void {
    
            setTimeout(() => window.location.reload(), 1000);
            
          }
          onFileChange(event) {
            if (event.target.files.length > 0) {
              this.file = event.target.files[0];
              this.uploadEvent = event;
            }
            let fileReader = new FileReader();
            fileReader.onload = (e) => {
              this.arrayBuffer = fileReader.result;
              //@ts-ignore
              var data = new Uint8Array(this.arrayBuffer);
              var arr = new Array();
              for (var i = 0; i != data.length; ++i)
                arr[i] = String.fromCharCode(data[i]);
              var bstr = arr.join("");
              var workbook = read(bstr, {
                type: "binary"
              });
              var first_sheet_name = workbook.SheetNames[0];
              var worksheet = workbook.Sheets[first_sheet_name];
              this.exceljsondata2 = utils.sheet_to_json(worksheet, {
                raw: true,
                defval: "",
              });
            };
            fileReader.readAsArrayBuffer(this.file);
          }
          afficher()
          {
            this.loading = true;
            this.UserService.addusers(this.exceljsondata2).then(
              (data:any) => {
                this.loading = false;
          Swal.fire({
                  position: 'center',
                  icon: 'success',
                  title: 'utilisateurs ajoutées avec succès!',
                  showConfirmButton: false,
                  timer: 6000 
                });
                    this.reloadPage();
              },
              (error) => {
                this.loading = false;
                
              }
            );
          }     
}
  